import { __extends } from "tslib";
import { getShadowElement } from '@tyler-components-web/core';
import { BaseAdapter } from '../../core/adapters/base-adapter';
import { toggleClass } from '../../core/utils';
import { FOOTER_CONSTANTS } from './footer-constants';
var FooterAdapter = /** @class */ (function (_super) {
    __extends(FooterAdapter, _super);
    function FooterAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._footerElement = getShadowElement(component, FOOTER_CONSTANTS.selectors.FOOTER);
        return _this;
    }
    FooterAdapter.prototype.setRole = function () {
        if (!this._component.hasAttribute('role')) {
            this._component.setAttribute('role', FOOTER_CONSTANTS.strings.ROLE);
        }
    };
    FooterAdapter.prototype.setAlternativeLayout = function (value) {
        toggleClass(this._footerElement, value, FOOTER_CONSTANTS.classes.ALTERNATIVE_LAYOUT);
    };
    return FooterAdapter;
}(BaseAdapter));
export { FooterAdapter };
